import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Context } from "pages/Integrations";
import { Toggle } from "shared/components/Toggle";
import { Select } from "@components";

export default class SodeDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      environmentId: EnvironmentStorage.getEnvironment()?.id,
      environment: "PRODUCTION",
      active: true,
      email: "",
      password: "",
      cancelationControl: false,
      allowPreview: false,
    };
  }

  componentDidMount() {
    this.loadAccount();
  }

  async loadAccount() {
    const { environmentId } = this.state;

    const accountResponse = await IntegrationsAPI.getSodeAccount(environmentId);
    const account = accountResponse.getData({});

    this.setState({
      environment: account?.environment || 'PRODUCTION',
      email: account?.email,
      password: account?.password,
      active: account?.active,
      cancelationControl: account?.cancelationControl || false,
      allowPreview: account?.allowPreview || false,
      loadingPage: false,
    });
  }

  async updateAccount(configs) {
    const { environmentId } = this.state;

    this.setState({
      loading: true,
    });

    const updateResponse = await IntegrationsAPI.upsertSodeAccount(
      environmentId,
      configs
    );

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({
        loading: false,
      });
      return false;
    }

    this.setState({
      loading: false,
    });

    return true;
  }

  async changeStep(newStep) {
    this.setState({
      step: newStep,
    });
  }

  render() {
    const {
      loading,
      loadingPage,
      environment,
      email,
      password,
      active
    } = this.state;

    const { visible, onClose } = this.props;

    const isValid = email && password;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Soldado de entrega"
      >
        <Context />

        {loadingPage && (
          <div className={styles.loading}>
            <Loading />
          </div>
        )}
        {!loadingPage && (
          <div className={styles.scrollContainer}>
            <div className={styles.toggle}>
              <div className="d-flex justify-end w-100">
                <Toggle
                  active={active}
                  onChange={(active) => this.setState({ active })}
                />
              </div>
            </div>

            <Select
              design="two"
              label="Ambiente"
              onChange={(e) => this.setState({ environment: e.target.value })}
              className="mb-20"
              value={environment}
              options={[
                {
                  label: "Produção",
                  value: "PRODUCTION",
                  selected: environment === "PRODUCTION",
                },
                {
                  label: "Homologação",
                  value: "SANDBOX",
                  selected: environment === "SANDBOX",
                },
              ]}
            />

            <Input
              design="two"
              label="E-mail"
              className="mb-20"
              value={email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />

            <Input
              design="two"
              label="Senha"
              type="password"
              className="mb-20"
              value={password}
              onChange={(e) => this.setState({ password: e.target.value })}
            />

            <div className={styles.footer}>
              <Button
                design="primary"
                className="w-100"
                onClick={() =>
                  this.updateAccount({
                    active: active,
                    environment,
                    email,
                    password,
                    cancelationControl: false,
                    allowPreview: false,
                    allowManualDispatch: false,
                  })
                }
                loading={loading}
                disabled={loading || !isValid}
              >
                Salvar
              </Button>
            </div>
          </div>
        )}
      </Drawer>
    );
  }
}
